import { Component, ViewChild, ElementRef, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { NcalayerService } from '../../@core/utils/ncalayer/ncalayer.service';
import { Cell, DefaultEditor, Editor } from 'ng2-smart-table';
import Swal from 'sweetalert2';

@Component({
  template: `
  <input    type="number"
     maxlength="12"
            #name
            [ngClass]="{'err-class': !checkInputNumber(), 'not-err-class': checkInputNumber()}"
            pattern="[0-9]*" 
            class="form-control short-input"
            (input)="this.ncalayer.changeSum($event.target.value)"        
            [name]="cell.getId()"
            [disabled]="!cell.isEditable()"
            [placeholder]="cell.getTitle()"
            (click)="onClickIDN($event)"
            (keyup)="updateValue()"
            (keydown.enter)="onEdited2($event)"
            (keydown.esc)="onStopEditing.emit()"/>
        
       <div [hidden]="true" [innerHTML]="cell.getValue()" #htmlValue></div>
  `,
  styleUrls: ['./payment.component.scss'],
})
export class CustomEditorComponent8 extends DefaultEditor implements AfterViewInit {
  @Output() valueChange: EventEmitter<string> = new EventEmitter();
  @ViewChild('name') name: ElementRef;
  @ViewChild('url') url: ElementRef;
  @ViewChild('htmlValue') htmlValue: ElementRef;
  Name = "";
  personsN: any[];
  selectedPersons: never[];
  constructor(public ncalayer: NcalayerService,) {
    super();
  }

  ngAfterViewInit() {

    this.personsN = JSON.parse(sessionStorage.getItem("persons"));
    if (this.cell.newValue !== '') {
      this.name.nativeElement.value = this.getUrlName();

    }
  }
  selected(arg: any) {
    // for (let i=0; i<this.personsN.length; i++){
    //   if (arg===this.personsN[i].IDN){
    //     for(let i=0; i<this.personsN.length; i++){ 
    //       this.selectedPersons.push(this.personsN[i].IDN,this.personsN[i].NM ,this.personsN[i].FM,this.personsN[i].FT);
    //   }

    this.valueChange.emit(arg);

    //   }
    // }
    // console.log(arg);

    // sessionStorage.setItem('selectedPersons',arg);
  }
  onInput(val: string) {
    this.valueChange.emit(val);
    this.updateValue()
  }
  onClickIDN(event: any) {

  }

  public updateValue() {
    // const href = this.url.nativeElement.value;
    const name = this.name.nativeElement.value;
    this.cell.newValue = name;
  }

  n: number = 0;
  checkInputNumber() {

    if (!Number.isInteger(parseInt(this.Name))) {
      this.cell.newValue = '';
      this.Name = "";
      this.name.nativeElement.value = "";
    }

    if (parseInt(this.Name) <= 0) {
      this.cell.newValue = '';
      this.Name = "";
      this.name.nativeElement.value = "";

      return false;
    }
    
    this.ncalayer.getChangeSum().subscribe((data: string) => {
      this.Name = data
    });

    if (/^[0-9].+$/.test(this.Name)) {
      this.updateValue();
      this.n = 0;
      return true;
    }
  }


  getUrlName(): string {
    return this.htmlValue.nativeElement.innerText;
  }

  getUrlHref(): string {
    return this.htmlValue.nativeElement.querySelector('a').getAttribute('href');
  }
  onEdited2(event: any) {
    console.log('event' + event + 'ters');
  }
}
